import React, {useState} from 'react';
import ModalWindow from '../modal-window';
import {useIntl} from 'react-intl';
import {ButtonVariant, GritxButton} from '@wholesalechange/chatcomponent';
import Input from '../input';
import InputDate from '../input-date';
import {InputTime} from '../input-time/InputTime';
import {ITrainingDialogue} from '../../redux/trainings/interfaces';

import './style.scss';

interface ITrainingModalWindow {
  dialogueCard: ITrainingDialogue;
  title: string;
  onSave: (dialogue: ITrainingDialogue) => void;
  onClose: () => void;
  show: boolean;
}

export const TrainingModalWindow = ({
  dialogueCard,
  title,
  onSave,
  onClose,
  show
}: ITrainingModalWindow): JSX.Element => {
  const intl = useIntl();
  const [dialogue, setDialogue] = useState<ITrainingDialogue>(dialogueCard);

  function handleClose() {
    setDialogue(dialogueCard);
    onClose();
  }

  const getValidFormStatus = (): boolean => {
    return !!dialogue.dialogName && dialogue.dialogName.trim() !== '' && !!dialogue.dialogUserDate;
  };

  function handleSave() {
    if (getValidFormStatus()) {
      onSave(dialogue);
    }
  }

  function handleChange(type: string): (e: string) => void {
    return (e) => {
      setDialogue({
        ...dialogue,
        [type]: e
      });
    };
  }

  function handleChangeDate(type: string): (e: Date) => void {
    return (e) => {
      setDialogue({
        ...dialogue,
        [type]: e
      });
    };
  }

  function handleChangeTime(type: string): (e: Date) => void {
    return (e) => {
      setDialogue({
        ...dialogue,
        [type]: e
      });
    };
  }

  const content = () => (
    <div className={'training-form__container'}>
      <div className={'form-training'}>
        <div className="form-training__header">
          <h2 className="form-training__title">{title}</h2>
        </div>
        <div className="form-training__body">
          <Input
            required
            type="text"
            value={dialogue.dialogName}
            label={intl.formatMessage({
              id: 'gritx.trainings.card.name.label',
              defaultMessage: 'Name'
            })}
            onChange={handleChange('dialogName')}
          />

          <InputDate
            required
            value={dialogue.dialogUserDate}
            label={intl.formatMessage({
              id: 'gritx.trainings.card.date.label',
              defaultMessage: 'Date'
            })}
            onChange={handleChangeDate('dialogUserDate')}
          />

          <InputTime
            required
            value={dialogue.dialogUserDate}
            label={intl.formatMessage({
              id: 'gritx.trainings.card.time.label',
              defaultMessage: 'Time'
            })}
            onChange={handleChangeTime('dialogUserDate')}
          />
        </div>
      </div>
    </div>
  );

  const formsButtons = () => (
    <div className="training-form__footer">
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.common.button.cancel',
          defaultMessage: 'Cancel'
        })}
        variant={ButtonVariant.Light}
        className="training-form__button"
        onClick={handleClose}
      />
      <GritxButton
        title={intl.formatMessage({
          id: 'gritx.common.button.save',
          defaultMessage: 'Save'
        })}
        variant={ButtonVariant.Primary}
        className="training-form__button"
        onClick={handleSave}
      />
    </div>
  );

  return (
    <ModalWindow
      show={show}
      className="training-form__modal"
      onHide={handleClose}
      footerElement={formsButtons()}
    >
      {content()}
    </ModalWindow>
  );
};
